import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';

import { ArcAngelModesService } from '../../../core/services/arc-angel-modes.service';
import { WindowService } from '../../../core/services/window.service';
import { ArcAngelMonitorModeService } from '../arc-angel-monitor-mode.service';

interface ActiveTrackingItem {
  id: string;
  title: string;
  missed?: boolean;
  indistress?: boolean;
  getFormattedDate(): string;
}

@Component({
  selector: 'app-active-tracking-list',
  standalone: true,
  imports: [],
  templateUrl: './active-tracking-list.component.html',
  styleUrl: './active-tracking-list.component.css'
})
export class ActiveTrackingListComponent implements OnInit, OnDestroy {
  active_tracking_items: ActiveTrackingItem[] = [];
  missed_tracking_items: ActiveTrackingItem[] = [];
  distressed_tracking_items: ActiveTrackingItem[] = [];
  total = 0;

  showActive = true;
  showMissed = false;
  showDistress = false;

  private trackingSub?: Subscription;

  constructor(
    private monitorModeService: ArcAngelMonitorModeService,
    private arcAngelModesService: ArcAngelModesService,
    private windowService: WindowService
  ) {}

  ngOnInit(): void {
    this.trackingSub = this.monitorModeService.monitorEvents$.subscribe(() => {
      this.updateTrackingLists();
    });
    this.updateTrackingLists();
  }

  ngOnDestroy(): void {
    this.trackingSub?.unsubscribe();
  }

  updateTrackingLists(): void {
    const tracking = this.monitorModeService.data.monitorActiveTracking || [];
    this.active_tracking_items = [];
    this.missed_tracking_items = [];
    this.distressed_tracking_items = [];

    tracking.forEach((item: ActiveTrackingItem) => {
      if (item.missed) {
        this.missed_tracking_items.push(item);
      }
      if (item.indistress) {
        this.distressed_tracking_items.push(item);
      }
      if (!item.missed && !item.indistress) {
        this.active_tracking_items.push(item);
      }
    });

    this.total = tracking.length;
  }

  setShowActive(): void {
    this.showActive = true;
    this.showDistress = false;
    this.showMissed = false;
  }

  setShowMissed(): void {
    this.showActive = false;
    this.showDistress = false;
    this.showMissed = true;
  }

  setShowDistress(): void {
    this.showActive = false;
    this.showDistress = true;
    this.showMissed = false;
  }

  activeTrackingEventClick(item: ActiveTrackingItem): void {
    const device = this.monitorModeService.getActiveTrackingDevice(item);
    if (device && typeof device.goToEntity === 'function') {
      device.goToEntity();
    }
  }

  viewActiveTrackingEvent(event: Event, item: ActiveTrackingItem): void {
    event.stopPropagation();
    this.windowService.openModalWindow(
      item,
      'ActiveTrackingBaseballCardDialogController',
      'components/arcangel/active_tracking/active-tracking-info-dialog.html'
    );
  }

  goLive(event: Event, item: ActiveTrackingItem): void {
    event.stopPropagation();
    this.arcAngelModesService.switchToLiveTrackingMode(item.id);
  }
}